import { SharedHomeworkPage } from "@/pages/SharedHomeworkPage";
import { createFileRoute } from "@tanstack/react-router";

// Deliberately outside /teacher: a shared link has to open without a staff sign-in.
export const Route = createFileRoute("/homework/$homeworkId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { homeworkId } = Route.useParams();
  return <SharedHomeworkPage homeworkId={homeworkId} />;
}
